(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["premium-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.spp').forEach(function(root){
  if(root.dataset.b) return; root.dataset.b='1';
  var cur=root.getAttribute('data-cur')||'$', after=root.getAttribute('data-after')||'drawer', drawerSel=root.getAttribute('data-drawer')||'', ptitle=root.getAttribute('data-title')||'';
  var fship=parseInt(root.getAttribute('data-fship'))||0, fmsg=root.getAttribute('data-fmsg')||'', fdone=root.getAttribute('data-fdone')||'';
  function m(c){ var n=c/100; return cur+n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,','); }
  function norm(s){ return String(s||'').toLowerCase().replace(/inches|inch|in\b/g,'').replace(/[×✕✖*]/g,'x').replace(/[^a-z0-9x]/g,''); }

  // gallery
  var thumbs=[].slice.call(root.querySelectorAll('.spp-thumb')), main=root.querySelector('.spp-main'), gi=0;
  function showImg(i){ if(!thumbs.length) return; gi=(i+thumbs.length)%thumbs.length; thumbs.forEach(function(t){t.classList.remove('on');}); var t=thumbs[gi]; t.classList.add('on'); t.scrollIntoView({block:'nearest'}); var f=t.getAttribute('data-full'); if(main){ main.style.opacity='0'; var im=new Image(); im.onload=function(){ main.src=f; main.style.opacity='1'; }; im.src=f; } }
  thumbs.forEach(function(t,i){ t.addEventListener('click',function(){showImg(i);}); });
  var pv=root.querySelector('.spp-prev'), nx=root.querySelector('.spp-next');
  if(pv) pv.addEventListener('click',function(){showImg(gi-1);});
  if(nx) nx.addEventListener('click',function(){showImg(gi+1);});

  var sizes=[].slice.call(root.querySelectorAll('.spp-size'));
  var now=root.querySelector('.spp-price-now'), was=root.querySelector('.spp-price-was'), save=root.querySelector('.spp-price-save');
  var addons=[].slice.call(root.querySelectorAll('.spp-addon'));
  var sel={vid:null,si:0,qty:1,size:''};
  var stSel=root.querySelector('.spp-sticky-size');

  function updateAddons(){
    addons.forEach(function(a){
      var list=[]; try{ list=JSON.parse(a.getAttribute('data-variants')); }catch(e){}
      var sp=a.getAttribute('data-sizepriced')==='1', v=null;
      if(sp){ v = list[sel.si] || null; }   /* match by size POSITION (1st..6th), not exact text */
      else { v=list[0]||null; }
      var nEl=a.querySelector('.spp-addon-now'), wEl=a.querySelector('.spp-addon-was');
      if(v && v.a!==false){ a.setAttribute('data-vid',v.id); a.classList.remove('spp-off'); nEl.textContent='+'+m(v.p);
        if(v.c&&v.c>v.p){ wEl.textContent=m(v.c); wEl.hidden=false; } else wEl.hidden=true;
      } else { a.setAttribute('data-vid',''); nEl.textContent='—'; wEl.hidden=true; a.classList.add('spp-off'); a.classList.remove('on'); }
    });
  }
  function pickSize(t){
    sizes.forEach(function(x){x.classList.remove('on');}); t.classList.add('on');
    sel.vid=t.getAttribute('data-vid'); sel.si=parseInt(t.getAttribute('data-sizeindex'))||0; sel.size=t.getAttribute('data-size')||'';
    var p=parseInt(t.getAttribute('data-price'))||0, c=parseInt(t.getAttribute('data-compare'))||0;
    now.textContent=m(p);
    if(c>p){ was.textContent=m(c); was.hidden=false; save.textContent='Save '+m(c-p); save.hidden=false; } else { was.hidden=true; save.hidden=true; }
    if(stSel) stSel.value=sel.si;
    updateAddons();
  }
  sizes.forEach(function(t){ t.querySelector('.spp-size-price').textContent=m(parseInt(t.getAttribute('data-price'))||0); t.addEventListener('click',function(){pickSize(t);}); });
  if(stSel){
    sizes.forEach(function(t,i){ var o=document.createElement('option'); o.value=i; o.textContent=(t.getAttribute('data-size')||'')+' - '+m(parseInt(t.getAttribute('data-price'))||0); stSel.appendChild(o); });
    stSel.addEventListener('change',function(){ var i=parseInt(stSel.value)||0; if(sizes[i]) pickSize(sizes[i]); });
  }
  if(sizes.length) pickSize(sizes[0]);

  root.querySelectorAll('.spp-addon,.spp-x').forEach(function(a){
    a.addEventListener('click',function(e){
      if(e.target.closest('a')) return;              /* let extra links open */
      e.preventDefault();
      if(a.classList.contains('spp-off')) return;
      var on=a.classList.toggle('on');
      var panel=a.nextElementSibling;
      if(panel && panel.classList.contains('spp-addon-colors')){
        panel.hidden=!on;
        if(!on){ a.removeAttribute('data-color'); panel.querySelectorAll('.spp-sw').forEach(function(s){s.classList.remove('on');}); }
      }
    });
  });
  // acrylic color swatches + drag scroll
  root.querySelectorAll('.spp-addon-colors').forEach(function(panel){
    var owner=panel.previousElementSibling;
    panel.querySelectorAll('.spp-sw').forEach(function(sw){
      sw.addEventListener('click',function(e){
        e.preventDefault(); e.stopPropagation();
        panel.querySelectorAll('.spp-sw').forEach(function(s){s.classList.remove('on');});
        sw.classList.add('on');
        if(owner) owner.setAttribute('data-color', sw.getAttribute('data-color'));
      });
    });
    var sc=panel.querySelector('.spp-swatches'), down=false, sx=0, sl=0, moved=false;
    if(sc){
      sc.addEventListener('pointerdown',function(e){ down=true; moved=false; sx=e.clientX; sl=sc.scrollLeft; sc.classList.add('drag'); });
      window.addEventListener('pointermove',function(e){ if(!down)return; if(Math.abs(e.clientX-sx)>3) moved=true; sc.scrollLeft=sl-(e.clientX-sx); });
      window.addEventListener('pointerup',function(){ down=false; sc.classList.remove('drag'); });
      sc.addEventListener('click',function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); } },true);
    }
  });

  // extras toggle
  var exWrap=root.querySelector('.spp-extras'), exBtn=root.querySelector('.spp-extras-toggle');
  if(exBtn) exBtn.addEventListener('click',function(){ exWrap.classList.toggle('open'); });

  var qi=root.querySelector('.spp-qinput');
  function setQ(n){ n=Math.max(1,parseInt(n)||1); sel.qty=n; if(qi) qi.value=n; var sq=root.querySelector('.spp-sqn'); if(sq) sq.textContent=n; }
  var qm=root.querySelector('.spp-qminus'), qp=root.querySelector('.spp-qplus');
  if(qm) qm.addEventListener('click',function(){setQ(sel.qty-1);});
  if(qp) qp.addEventListener('click',function(){setQ(sel.qty+1);});
  if(qi) qi.addEventListener('change',function(){setQ(qi.value);});

  function items(){
    var arr=[], signProps={};
    root.querySelectorAll('.spp-addon.on').forEach(function(a){ var v=a.getAttribute('data-vid'); if(v){ var pr={'_bundle':String(sel.vid),'Add-on for':ptitle,'_kind':'rec'}; var col=a.getAttribute('data-color'); if(col) pr['Sheet color']=col; arr.push({id:Number(v),quantity:sel.qty,properties:pr}); } });
    root.querySelectorAll('.spp-x.on').forEach(function(x){
      var v=x.getAttribute('data-vid');
      if(x.getAttribute('data-free')==='1' || !v){ signProps[x.getAttribute('data-name')] = (x.getAttribute('data-free')==='1' ? 'Free' : 'Yes'); return; }
      arr.push({id:Number(v),quantity:sel.qty,properties:{'_bundle':String(sel.vid),'Add-on for':ptitle,'_kind':'extra'}});
    });
    return {arr:arr, signProps:signProps};
  }
  // ---- cart drawer ----
  var drawer=root.querySelector('.spp-drawer'), dov=root.querySelector('.spp-drawer-ov');
  function showDrawer(){ if(!drawer) return; drawer.hidden=false; dov.hidden=false; requestAnimationFrame(function(){ drawer.classList.add('open'); dov.classList.add('open'); }); }
  function hideDrawer(){ if(!drawer) return; drawer.classList.remove('open'); dov.classList.remove('open'); setTimeout(function(){ drawer.hidden=true; dov.hidden=true; },320); }
  if(dov) dov.addEventListener('click',hideDrawer);
  var dx=root.querySelector('.spp-drawer-x'); if(dx) dx.addEventListener('click',hideDrawer);
  function changeLine(line,qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:qty})})
      .then(function(r){return r.json();}).then(function(cart){ renderDrawer(cart); }).catch(function(){});
  }
  var dItemsBox=root.querySelector('.spp-drawer-items');
  if(dItemsBox){ dItemsBox.addEventListener('click',function(e){ var b=e.target.closest('[data-line]'); if(!b) return; e.preventDefault(); changeLine(parseInt(b.getAttribute('data-line')),parseInt(b.getAttribute('data-q'))); }); }
  function renderDrawer(cart){
    var box=root.querySelector('.spp-drawer-items');
    if(box){ var h='';
      var rank=function(it){ if(!(it.properties && it.properties._bundle)) return 0; return it.properties._kind==='extra'?2:1; };
      var list=cart.items.map(function(it,i){ return {it:it, line:i+1}; });
      list.sort(function(a,b){ return rank(a.it)-rank(b.it); });
      list.forEach(function(o){
        var it=o.it, line=o.line;
        var isAddon = !!(it.properties && it.properties._bundle);
        var opts = (!isAddon && it.variant_title && it.variant_title!=='Default Title') ? it.variant_title : '';
        var props=''; if(it.properties){ for(var k in it.properties){ if(k.charAt(0)==='_') continue; props+='<span class="spp-di-prop">'+k+': '+it.properties[k]+'</span>'; } }
        var ctl='<div class="spp-di-ctl"><div class="spp-di-step"><button type="button" data-line="'+line+'" data-q="'+(it.quantity-1)+'" aria-label="Decrease">&minus;</button><span>'+it.quantity+'</span><button type="button" data-line="'+line+'" data-q="'+(it.quantity+1)+'" aria-label="Increase">+</button></div><button type="button" class="spp-di-rm" data-line="'+line+'" data-q="0">Remove</button></div>';
        h+='<div class="spp-di">'+(it.image?'<img src="'+it.image+'" alt="" width="62" height="62">':'<div class="spp-di-ph"></div>')+'<div class="spp-di-b"><div class="spp-di-t">'+it.product_title+(isAddon?' <em class="spp-di-tag">Add-on</em>':'')+'</div>'+(opts?'<div class="spp-di-o">'+opts+'</div>':'')+props+ctl+'</div><div class="spp-di-p">'+m(it.final_line_price)+'</div></div>';
      });
      box.innerHTML=h||'<p class="spp-di-empty">Your cart is empty.</p>';
    }
    var s=root.querySelector('.spp-drawer-sub'); if(s) s.textContent=m(cart.total_price);
    var shipEl=root.querySelector('.spp-ship');
    if(shipEl && fship>0){
      shipEl.hidden=false;
      var t=cart.total_price, msg=shipEl.querySelector('.spp-ship-msg'), bar=shipEl.querySelector('.spp-ship-bar i');
      if(t>=fship){ shipEl.classList.add('done'); msg.innerHTML='&#10003; '+fdone; bar.style.width='100%'; }
      else { shipEl.classList.remove('done'); msg.innerHTML="You're <b>"+m(fship-t)+"</b> "+fmsg; bar.style.width=Math.min(100,(t/fship*100))+'%'; }
    }
  }
  function openCartDrawer(){ fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ renderDrawer(c); showDrawer(); }).catch(showDrawer); }

  function add(cb){
    if(!sel.vid) return;
    var i=items(), btns=root.querySelectorAll('.spp-add,.spp-buy,.spp-sticky-add');
    btns.forEach(function(b){b.classList.add('loading');});
    var H={'Content-Type':'application/json','Accept':'application/json'};
    /* Checkout shows newest first, so add the add-ons first (reversed) and the SIGN LAST -> sign on top */
    var queue=i.arr.slice().reverse().concat([{id:Number(sel.vid),quantity:sel.qty,properties:i.signProps}]);
    (function next(k){
      if(k>=queue.length){ btns.forEach(function(b){b.classList.remove('loading');}); cb(); return; }
      fetch('/cart/add.js',{method:'POST',headers:H,body:JSON.stringify({items:[queue[k]]})})
        .then(function(r){ if(!r.ok) throw r; return r.json(); })
        .then(function(){ next(k+1); })
        .catch(function(){ window.location.href='/cart'; });
    })(0);
  }
  function doAdd(){ add(function(){ if(after==='cart'){ window.location.href='/cart'; } else { openCartDrawer(); } }); }
  var addBtn=root.querySelector('.spp-add'), buyBtn=root.querySelector('.spp-buy'), stBtn=root.querySelector('.spp-sticky-add');
  if(addBtn) addBtn.addEventListener('click',doAdd);
  if(stBtn) stBtn.addEventListener('click',doAdd);
  if(buyBtn) buyBtn.addEventListener('click',function(){ add(function(){ window.location.href='/checkout'; }); });

  // sticky qty
  var sqm=root.querySelector('.spp-sqm'), sqp=root.querySelector('.spp-sqp');
  if(sqm) sqm.addEventListener('click',function(){ setQ(sel.qty-1); });
  if(sqp) sqp.addEventListener('click',function(){ setQ(sel.qty+1); });

  // sticky visibility: appears after you scroll past the main buttons, hides once you leave this section
  var sticky=root.querySelector('.spp-sticky'), cta=root.querySelector('.spp-cta');
  function stickyCheck(){
    if(!sticky||!cta) return;
    var c=cta.getBoundingClientRect();
    sticky.hidden = !(c.bottom < 70);   /* show once main buttons scroll off, stay for the whole page */
  }
  window.addEventListener('scroll', stickyCheck, {passive:true});
  window.addEventListener('resize', stickyCheck);
  stickyCheck();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-addons"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-spa]').forEach(function (root) {
  if (root.dataset.init) return;
  root.dataset.init = '1';

  var variants = [];
  var moneyFmt = ''; /* filled from the shop's money format below */
  var vNode = root.querySelector('[data-variants]');
  var mNode = root.querySelector('[data-money]');
  try { if (vNode) variants = JSON.parse(vNode.textContent) || []; } catch (e) {}
  try { if (mNode) moneyFmt = JSON.parse(mNode.textContent) || moneyFmt; } catch (e) {}

  function money(cents) {
    if (cents === null || cents === undefined) return '';
    var dec = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var non = (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    /* If the shop format did not load, fall back to a plain amount */
    if (!moneyFmt) return dec;
    return moneyFmt
      .replace(/\{\{\s*amount\s*\}\}/g, dec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, non)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, dec.replace(/,/g, '.').replace(/\.(\d\d)$/, ',$1'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, non);
  }

  /* Thumbnails */
  var main = root.querySelector('[data-main]');
  root.querySelectorAll('.spa-thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!main || !t.dataset.src) return;
      main.removeAttribute('srcset');
      main.src = t.dataset.src;
      root.querySelectorAll('.spa-thumb').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
    });
  });

  /* Quantity */
  var qty = root.querySelector('.spa-qty-in');
  root.querySelectorAll('.spa-qty-btn').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!qty) return;
      var v = parseInt(qty.value, 10) || 1;
      qty.value = Math.max(1, v + parseInt(b.dataset.step, 10));
    });
  });

  /* Variants → price / SKU / availability */
  var form      = root.querySelector('form');
  var vidInput  = root.querySelector('[data-vid]');
  var priceEl   = root.querySelector('[data-price]');
  var compareEl = root.querySelector('[data-compare]');
  var skuEl     = root.querySelector('[data-sku]');
  var addBtn    = root.querySelector('[data-add]');
  var addText   = root.querySelector('[data-add-text]');
  var buyBtn    = root.querySelector('[data-buynow]');
  var optInputs = Array.prototype.slice.call(root.querySelectorAll('[data-opt-index]'));
  var addLabel  = addText ? addText.textContent.trim() : 'Add to Cart';

  function matchVariant() {
    var want = [];
    optInputs.forEach(function (i) {
      if (i.checked) want[parseInt(i.dataset.optIndex, 10)] = i.value;
    });
    if (!want.length) return variants[0];
    for (var n = 0; n < variants.length; n++) {
      var ok = true;
      for (var k = 0; k < want.length; k++) {
        if (want[k] && variants[n].options[k] !== want[k]) { ok = false; break; }
      }
      if (ok) return variants[n];
    }
    return null;
  }

  function update() {
    optInputs.forEach(function (i) {
      if (!i.checked) return;
      var lbl = root.querySelector('[data-opt-picked="' + i.dataset.optIndex + '"]');
      if (lbl) lbl.textContent = i.value;
    });

    var v = matchVariant();

    if (!v) {
      if (addBtn) addBtn.disabled = true;
      if (buyBtn) buyBtn.disabled = true;
      if (addText) addText.textContent = 'Unavailable';
      return;
    }

    if (vidInput) vidInput.value = v.id;
    if (priceEl) priceEl.textContent = money(v.price);

    if (compareEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compareEl.textContent = money(v.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (skuEl && v.sku) skuEl.textContent = v.sku;

    if (addBtn) addBtn.disabled = !v.available;
    if (buyBtn) buyBtn.disabled = !v.available;
    if (addText) addText.textContent = v.available ? addLabel : 'Sold out';

    if (v.featured_image && v.featured_image.src && main) {
      main.removeAttribute('srcset');
      main.src = v.featured_image.src;
    }

    if (window.history && history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      } catch (e) {}
    }
  }

  optInputs.forEach(function (i) { i.addEventListener('change', update); });
  if (optInputs.length) update();

  /* Colour name beside the label */
  var picked = root.querySelector('[data-picked]');
  function syncColor() {
    var sel = root.querySelector('.spa-chipw input:checked');
    if (picked) picked.textContent = sel ? sel.value : '';
  }
  root.querySelectorAll('.spa-chipw input').forEach(function (i) {
    i.addEventListener('change', syncColor);
  });
  syncColor();

  /* Buy Now — add to cart, then straight to checkout */
  if (buyBtn && form) {
    buyBtn.addEventListener('click', function () {
      buyBtn.classList.add('is-busy');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          buyBtn.classList.remove('is-busy');
          form.submit();
        });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-announcement-section"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sp-ann').forEach(function(bar){
  if(bar.dataset.init) return; bar.dataset.init='1';
  var items=[].slice.call(bar.querySelectorAll('.sp-ann-item'));
  if(items.length<2) return;
  var i=0, speed=parseInt(bar.getAttribute('data-speed'))||4000, timer=null;
  function go(){ items[i].classList.remove('active'); i=(i+1)%items.length; items[i].classList.add('active'); }
  function play(){ stop(); timer=setInterval(go,speed); }
  function stop(){ if(timer){ clearInterval(timer); timer=null; } }
  play();
  bar.addEventListener('mouseenter',stop);
  bar.addEventListener('mouseleave',play);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-beforeafter-section"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ba-compare').forEach(function(box){
  if(box.dataset.init) return; box.dataset.init = '1';
  var range=box.querySelector('.ba-range'); if(!range) return;
  function set(v){ box.style.setProperty('--pos', v + '%'); }
  set(range.value);
  range.addEventListener('input', function(){ box.classList.add('touched'); box.dataset.user='1'; set(range.value); });

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function autoSweep(){
    if(box.dataset.user || reduce) return;
    var pts=[Number(range.value)||50,85,15,50], seg=0, dur=850, start=null, from=pts[0];
    function frame(ts){
      if(box.dataset.user) return;
      if(start===null) start=ts;
      var t=(ts-start)/dur;
      if(t>=1){ seg++; if(seg>=pts.length-1){ set(pts[pts.length-1]); range.value=pts[pts.length-1]; return; } start=ts; from=pts[seg]; t=0; }
      var e = t<.5 ? 2*t*t : 1-Math.pow(-2*t+2,2)/2;
      var v = from + (pts[seg+1]-from)*e;
      set(v); range.value=v;
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ setTimeout(autoSweep,400); io.disconnect(); } });},{threshold:.4});
    io.observe(box);
  } else { setTimeout(autoSweep,600); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sp-faq').forEach(function(root){
  if(root.dataset.b) return; root.dataset.b='1';
  var items=[].slice.call(root.querySelectorAll('.sp-faq-item'));
  items.forEach(function(it){
    var q=it.querySelector('.sp-faq-q'), a=it.querySelector('.sp-faq-a');
    q.addEventListener('click',function(){
      var open=it.classList.toggle('open');
      a.style.maxHeight = open ? (a.scrollHeight+'px') : '0px';
    });
  });
  var input=root.querySelector('.sp-faq-input'), none=root.querySelector('.sp-faq-none');
  if(input){
    input.addEventListener('input',function(){
      var v=input.value.trim().toLowerCase(), shown=0;
      items.forEach(function(it){
        var txt=(it.getAttribute('data-q')||'').toLowerCase()+' '+(it.querySelector('.sp-faq-a-in')?it.querySelector('.sp-faq-a-in').textContent.toLowerCase():'');
        var hit=!v||txt.indexOf(v)>-1; it.style.display=hit?'':'none'; if(hit) shown++;
      });
      if(none) none.hidden = shown>0;
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-gallery"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sp-gc').forEach(function(root){
  if(root.dataset.b) return; root.dataset.b='1';
  var tabs=[].slice.call(root.querySelectorAll('.sp-gc-tab'));
  var items=[].slice.call(root.querySelectorAll('.sp-gc-item'));
  function apply(f){
    tabs.forEach(function(x){ x.classList.toggle('on', x.getAttribute('data-filter')===f); });
    items.forEach(function(it){
      var role=it.getAttribute('data-role'), cat=it.getAttribute('data-cat');
      var show = (f==='all') ? (role==='cover') : (role==='tile' && cat===f);
      it.style.display = show ? '' : 'none';
    });
  }
  tabs.forEach(function(t){ t.addEventListener('click',function(){ apply(t.getAttribute('data-filter')); }); });
  root.querySelectorAll('.sp-gc-cover').forEach(function(c){
    c.addEventListener('click',function(){ apply(c.getAttribute('data-cat')); root.querySelector('.sp-gc-filter').scrollIntoView({behavior:'smooth',block:'nearest'}); });
  });
  apply('all');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sph3').forEach(function(root){
  if(root.dataset.init) return; root.dataset.init='1';
  var slides=[].slice.call(root.querySelectorAll('.sph3-slide')),
      dots=[].slice.call(root.querySelectorAll('.sph3-dot')),
      si=0, speed=parseInt(root.getAttribute('data-speed'))||6000,
      auto=root.getAttribute('data-autoplay')==='1';
  function playActive(){
    slides.forEach(function(sl,idx){
      sl.querySelectorAll('video').forEach(function(v){
        v.muted=true;
        if(idx===si){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); } else { v.pause(); }
      });
    });
  }
  function go(n){
    slides[si].classList.remove('active'); if(dots[si])dots[si].classList.remove('active');
    si=(n+slides.length)%slides.length;
    slides[si].classList.add('active'); if(dots[si])dots[si].classList.add('active');
    playActive();
  }
  dots.forEach(function(d,i){ d.addEventListener('click',function(){ go(i); }); });
  playActive();
  if(slides.length>1 && auto){ setInterval(function(){ go(si+1); }, speed); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-products-section"] && !Shopify.designMode) return;
  try {
    
(function(){
  var toast, hideT;
  function ensureToast(){
    if(toast) return toast;
    toast=document.createElement('div');
    toast.className='sp-toast';
    toast.innerHTML='<img class="sp-toast-img" alt="" hidden>'
      +'<div class="sp-toast-body">'
      +'<span class="sp-toast-label"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l4.5 4.5L19 7"/></svg>Added to cart</span>'
      +'<span class="sp-toast-name"></span>'
      +'<a class="sp-toast-cart" href="/cart">View cart &rarr;</a>'
      +'</div>';
    document.body.appendChild(toast);
    return toast;
  }
  function showToast(name, img){
    var t=ensureToast();
    var im=t.querySelector('.sp-toast-img');
    if(img){ im.src=img; im.hidden=false; } else { im.hidden=true; }
    t.querySelector('.sp-toast-name').textContent = name || 'Item added';
    t.classList.add('show'); clearTimeout(hideT); hideT=setTimeout(function(){ t.classList.remove('show'); },3200);
  }
  var CART_SELS='.cart-count,[data-cart-count],.cart-count-bubble,.cart-icon-bubble,.m-cart-count,.header__cart-count,.site-header__cart-count,.cart-counter,.cart__count,[data-cart-count-bubble],.js-cart-count,.header-cart-count,.cart-link__bubble,.mini-cart-count';
  function setCount(n){
    document.querySelectorAll(CART_SELS).forEach(function(el){ el.textContent=n; el.classList.remove('hidden','is-empty'); el.style.display=''; });
    ['cart:updated','cart:refresh','cart:build','ajaxProduct:added','product:added','cart:added'].forEach(function(ev){ document.dispatchEvent(new CustomEvent(ev)); });
  }

  document.querySelectorAll('.sp-prod .pc-add').forEach(function(form){
    if(form.dataset.init) return; form.dataset.init='1';
    form.addEventListener('submit', function(e){
      if(!window.fetch) return;
      e.preventDefault();
      var btn=form.querySelector('button'); if(!btn||btn.disabled) return;
      var card=form.closest('.sp-pcard');
      var name=((card.querySelector('h3')||{}).textContent||'').trim();
      var imgEl=card.querySelector('.img-main')||card.querySelector('.pc-media img');
      var img=imgEl ? imgEl.getAttribute('src') : '';
      var id=form.querySelector('[name=id]').value;
      btn.disabled=true;
      // optimistic instant count bump
      var cur=document.querySelector(CART_SELS); var base=cur?(parseInt(cur.textContent,10)||0):0; setCount(base+1);
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
        .then(function(r){ if(!r.ok) throw 0; return r.json(); })
        .then(function(){
          showToast(name, img);
          fetch('/cart.js').then(function(r){return r.json();}).then(function(c){ setCount(c.item_count); }).catch(function(){});
          setTimeout(function(){ btn.disabled=false; },700);
        })
        .catch(function(){ form.submit(); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-reviews-section"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sp-rev').forEach(function (root) {
  if (root.dataset.revInit) return;
  root.dataset.revInit = '1';

  var track = root.querySelector('.sp-rev-track');
  if (!track) return;

  var prev = root.querySelector('.sp-rev-arrow.prev');
  var next = root.querySelector('.sp-rev-arrow.next');
  var idx = 0;

  /* ── Belt-and-braces image guard ───────────────────────────────────────
     Images now load eagerly (see the <img> markup), so there is no lazy
     timing bug. This only exists to undo a theme-level lazy-load library
     (Minimog ships lazysizes) if it ever swaps our src for a placeholder:
     if an image has a data-src but a blank/placeholder src, restore it.   */
  root.querySelectorAll('img[data-rev-img]').forEach(function (img) {
    img.loading = 'eager';
    var ds = img.getAttribute('data-src');
    if (ds && (!img.getAttribute('src') || img.src.indexOf('data:image') === 0)) {
      img.src = ds;
    }
  });

  /* ── Carousel ─────────────────────────────────────────────────────── */
  function gap() {
    var g = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap);
    return isNaN(g) ? 18 : g;
  }
  function stepW() {
    var c = track.querySelector('.sp-rev-card');
    return c ? c.offsetWidth + gap() : 360;
  }
  function maxIdx() {
    return Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / stepW()));
  }
  function syncArrows() {
    if (prev) prev.disabled = idx <= 0;
    if (next) next.disabled = idx >= maxIdx();
  }
  function goTo(i) {
    idx = Math.max(0, Math.min(i, maxIdx()));
    track.scrollTo({ left: idx * stepW(), behavior: 'smooth' });
    syncArrows();
  }

  track.scrollLeft = 0;
  idx = 0;
  syncArrows();

  if (prev) prev.addEventListener('click', function () { goTo(idx - 1); });
  if (next) next.addEventListener('click', function () { goTo(idx + 1); });

  var st;
  track.addEventListener('scroll', function () {
    clearTimeout(st);
    st = setTimeout(function () {
      idx = Math.round(track.scrollLeft / stepW());
      syncArrows();
    }, 140);
  }, { passive: true });

  /* ── Autoplay ─────────────────────────────────────────────────────── */
  if (root.dataset.autoplay === 'true') {
    var speed = parseInt(root.dataset.speed, 10) || 4000;
    var timer = null;

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function tick() {
      if (document.hidden) return;            /* don't advance in a background tab */
      if (idx >= maxIdx()) { goTo(0); } else { goTo(idx + 1); }
    }
    function play() { stop(); if (maxIdx() > 0) timer = setInterval(tick, speed); }

    play();
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    track.addEventListener('touchstart', stop, { passive: true });
    track.addEventListener('touchend', function () { setTimeout(play, 3000); }, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { play(); }
    });

    /* Debounced — the old version stacked a new interval on every resize
       event, which fires constantly as mobile browsers hide the URL bar. */
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { syncArrows(); play(); }, 200);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-trending"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sp-trend').forEach(function(root){
  var vp = root.querySelector('.sp-trend-marquee');
  var track = root.querySelector('.sp-trend-track');
  if(!vp || !track || vp.dataset.bound) return;
  vp.dataset.bound = '1';

  var speed = parseFloat(root.getAttribute('data-speed')) || 45;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var half = 0;
  function measure(){ half = track.scrollWidth / 2; }
  measure();
  window.addEventListener('resize', measure);
  if('ResizeObserver' in window){ new ResizeObserver(measure).observe(track); }

  function pxPerMs(){ return half > 0 ? (half / (speed * 1000)) : 0; }
  function wrap(){
    if(half <= 0) return;
    if(vp.scrollLeft >= half) vp.scrollLeft -= half;
    else if(vp.scrollLeft < 0) vp.scrollLeft += half;
  }

  var paused = reduce, holding = false, moved = false, hovering = false;
  var startX = 0, lastX = 0, last = null;

  function loop(ts){
    if(last === null) last = ts;
    var dt = ts - last; last = ts;
    if(!paused && !holding && !hovering && dt < 100){
      vp.scrollLeft += pxPerMs() * dt;
    }
    wrap();
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);

  // Desktop: pause while the cursor rests on the row so people can browse
  vp.addEventListener('mouseenter', function(){ hovering = true; });
  vp.addEventListener('mouseleave', function(){ hovering = false; });

  // Grab / swipe to browse. No pointer capture -> link clicks keep working.
  vp.addEventListener('pointerdown', function(e){
    if(e.pointerType === 'mouse' && e.button !== 0) return;
    holding = true; moved = false; startX = e.clientX; lastX = e.clientX;
    vp.classList.add('is-grabbing');
  });
  function onMove(e){
    if(!holding) return;
    var dx = e.clientX - lastX; lastX = e.clientX;
    if(Math.abs(e.clientX - startX) > 4) moved = true;
    if(moved){ vp.scrollLeft -= dx; wrap(); }
  }
  function onUp(){
    if(!holding) return;
    holding = false;
    vp.classList.remove('is-grabbing');
  }
  window.addEventListener('pointermove', onMove, { passive: true });
  window.addEventListener('pointerup', onUp);
  window.addEventListener('pointercancel', onUp);

  // Only cancel navigation when the user genuinely dragged (>4px), not on a plain click
  vp.addEventListener('click', function(e){
    if(moved){ e.preventDefault(); e.stopPropagation(); moved = false; }
  }, true);
});

  } catch(e) { console.error(e); }
})();
})();
